// C:\MonProjet\BBW_DELEGUER\localhost\babyworld-backoffice\babyworld-backoffice\src\pages\doctors\DoctorsPage\columns.js

import { DeleteOutlined, EditOutlined, StarFilled } from "@ant-design/icons";
import { Button, Space, Tag, Typography, Tooltip } from "antd"; // <-- CORRECTION ICI : Ajout de Space et Tag



import React from "react";

const { Text } = Typography;

export const columns = (naviagteTo, showModal, onNameClick) => [
    {
        title: "Nom",
        key: "name",
        width: 160,
        render: (record) => (
            <Space>
                <a onClick={() => onNameClick(record.id, `${record.firstname} ${record.lastname}`)}>
                    <Text strong style={{ 
                        color: record.isPartner ? '#d4b106' : '#1890ff', // Couleur Or si partenaire
                        textDecoration: 'underline' 
                    }}>
                        {record.firstname}
                    </Text>
                </a>
                {record.isPartner && (
                    <Tooltip title={record.partnerNotes || "Médecin Partenaire"}>
                        <StarFilled style={{ color: '#fadb14', fontSize: '16px' }} />
                    </Tooltip>
                )}
            </Space>
        ),
    },
    {
        title: "Prénom",
        dataIndex: "lastname",
        key: "lastname",
        width: 80,
    },
    {
        title: "Personnes Assignées",
        dataIndex: "delegates",
        key: "delegates",
        width: 180,
        render: (delegates) => (
            <>
                {delegates && delegates.length > 0 ? (
                    <Space size={[0, 8]} wrap>
                        {delegates.map((delegate) => (
                            <Tag color="blue" key={delegate.id}>
                                {`${delegate.firstname} ${delegate.lastname}`}
                            </Tag>
                        ))}
                    </Space>
                ) : (
                    <Tag color="orange">Non assigné</Tag>
                )}
            </>
        ),
    },
    
    {
        title: "Spécialités",
        dataIndex: "doctor",
        key: "speciality",
        render: (data) => <>{data?.specialty?.abreviation}</>,
        width: 80, // Largeur fixe
    },
    
    {
        title: "Type",
        dataIndex: "doctor",
        key: "doctorType",
        render: (data) => <>{data?.doctorType === 1 ? "Hospitalier" : "Privé"}</>,
        width: 60, // Largeur fixe
    },
    {
        title: "Gouvernorat",
        dataIndex: "government",
        key: "gouvernorat",
        render: (data) => <>{data?.name}</>,
        width: 120, // Largeur fixe
    },
    {
        title: "Région",
        dataIndex: "region",
        key: "region",
        render: (data) => <>{data?.name}</>,
        width: 120, // Largeur fixe
    },
    {
        title: "Address",
        dataIndex: "address",
        key: "address",
        width: 250, // Plus de place pour l'adresse
        ellipsis: true,
    },
    {
        title: "Téléphone",
        dataIndex: "phoneNumber",
        key: "phone",
        width: 120, // Largeur fixe
        ellipsis: true,
    },
    {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: 200, // Plus de place pour l'email
    },
    {
        title: "Potentiel",
        dataIndex: "potential",
        key: "potential",
        width: 110,
        align: 'center',
        render: (text) => {
            // Transformation en majuscule et suppression des espaces
            const val = text ? text.trim().toUpperCase() : ''; 
            if (!val) return <Text type="secondary">-</Text>;

            let color = 'default';
            
            // --- LOGIQUE COMPLÈTE POUR LES 5 NIVEAUX ---
            if (val === 'A+' || val === 'A') {
                color = 'green';
            } else if (val === 'B+' || val === 'B') {
                color = 'blue';
            } else if (val === 'C') {
                color = 'orange';
            }

            return (
                <Tag 
                    color={color} 
                    style={{ 
                        width: '55px',           // Largeur augmentée pour accueillir le "+" sans décalage
                        height: '24px',          // Hauteur fixe
                        display: 'inline-flex', 
                        justifyContent: 'center', 
                        alignItems: 'center',
                        fontWeight: '600',       // Très gras pour bien voir le "+"
                        margin: 0,
                        fontSize: '13px',        // Police légèrement plus grande
                        borderRadius: '4px',
                        padding: 0,
                        border: `1px solid ${color === 'default' ? '#d9d9d9' : 'transparent'}`
                    }}
                >
                    {val}
                </Tag>
            );
        },
    },
    {
        title: "Action",
        key: "action",
        fixed: 'right', // <-- ANCRER LA COLONNE À DROITE
        width: 220,     // <-- LARGEUR FIXE POUR LES BOUTONS
        render: (record) => (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {/* BOUTON MODIFIER (Style Bleu Foncé) */}
                <Button
                    className="btn-details" // Utilise la classe CSS globale qu'on a ajoutée
                    onClick={() => naviagteTo(`edit/médecin/${record.id}`)}
                    icon={<EditOutlined />} // Icône intégrée
                >
                    Modifier
                </Button>

                {/* BOUTON SUPPRIMER (Icône Rouge) */}
                <Button 
                    type="text" 
                    danger 
                    onClick={() => showModal(record.id)}
                    icon={<DeleteOutlined style={{ fontSize: '18px' }} />}
                />
            </div>
        ),
    },
];